import { darken } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useMassActionsBarStyles = makeStyles()((theme) => ({
  actionButton: {
    '&&': {
      color: theme.palette.primary.contrastText,
    },
    '&&:hover': {
      color: theme.palette.primary.contrastText,
      backgroundColor: darken(theme.palette.accent.dark, 0.95),
    },
    '&&[data-active="true"]': {
      color: theme.palette.primary.contrastText,
      backgroundColor: darken(theme.palette.accent.dark, 0.95),
    },
  },
  checkbox: {
    '&&': {
      color: theme.palette.secondary.light,
      '--form-indicator-color': theme.palette.accent.dark,
    },
    '&&:hover': {
      color: theme.palette.secondary.light,
    },
    '&&.Mui-checked, &&.MuiCheckbox-indeterminate': {
      color: theme.palette.secondary.light,
    },
  },
}));
